<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <div class="d-flex justify-space-between flex-wrap">
            <v-btn
              class="ma-2"
              dark
              color="secondary"
              outlined
              @click="$router.back()"
            >
              <v-icon>mdi-arrow-left</v-icon>
              Back
            </v-btn>
          </div>
        </v-card-title>
        <v-card-title class="mx-7 mb-5 pa-0">Signup</v-card-title>
        <div class="px-5 pb-15">
          <v-form ref="form">
            <v-select
              :items="getCourseLookup"
              item-text="title"
              item-value="id"
              class="my-5"
              prepend-icon="mdi-text"
              outlined
              :rules="[requiredRule]"
              v-model="sign_up.course_lookup_id"
              label="Course"
              hide-details="auto"
            ></v-select>
            <v-text-field
              label="Company name"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.company_name"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Company type"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.company_type"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Franchise partner name"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.franchise_partner_name"
              color="primary"
              hide-details="auto"
            ></v-text-field>

            <v-text-field
              label="Email"
              class="my-5"
              outlined
              :rules="[requiredRule, emailRule]"
              type="email"
              prepend-icon="mdi-email"
              v-model="sign_up.email"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Phone"
              class="my-5"
              :rules="[requiredRule]"
              outlined
              :min="0"
              type="number"
              prepend-icon="mdi-phone"
              v-model="sign_up.phone"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Employee amount"
              class="my-5"
              outlined
              :min="0"
              :rules="[requiredRule]"
              type="number"
              prepend-icon="mdi-numeric"
              v-model="sign_up.employee_amount"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Address name"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_name"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Billing address VAT number"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_vat_number"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Billing address to attention"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_to_attention"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Billing address street"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_street"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Billing address house number"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_house_number"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Billing address zipcode"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_zipcode"
              color="primary"
              hide-details="auto"
            ></v-text-field>
            <v-text-field
              label="Billing address city"
              class="my-5"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="sign_up.billing_address_city"
              color="primary"
              hide-details="auto"
            ></v-text-field>

            <v-switch
              class="pa-0 mx-7"
              inset
              v-model="sign_up.status"
              label="Status"
              :true-value="1"
              :false-value="0"
              color="primary"
            ></v-switch>
            <v-switch
              class="pa-0 mx-7"
              inset
              v-model="sign_up.is_paid"
              label="Paid"
              :true-value="1"
              :false-value="0"
              color="primary"
            ></v-switch>
            <v-btn
              color="primary"
              class="float-right"
              @click="save()"
              :loading="loading"
            >
              {{ isCreate ? "Create Signup" : "Edit Signup" }}
            </v-btn>
          </v-form>
        </div>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";
import { storeSignup } from "@/services/signUpService";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Create-Edit Signup",
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    if (!this.isCreate) {
      this.sign_up = _.find(this.getSignup, {
        id: Number(this.$route.params.id),
      });
    }
  },
  data() {
    return {
      loading: false,
      selectedCourseId: null,
      sign_up: {
        is_paid: 0,
        status: 0,
      },
      requiredRule: (v) => !!v || "This is required.",
      emailRule: (v) =>
        !!v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    };
  },
  methods: {
    ...mapActions(["showSnackbar", "setSignup"]),
    async save() {
      this.loading = true;
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("showSnackbar", "One or more fields are invalid.");
        this.loading = false;
        return;
      }

      try {
        await storeSignup(this.sign_up);
        await this.setSignup();
        this.$router.push("/app/sign-up");
      } catch (error) {
        await this.showSnackbar("Something went wrong");
      }

      this.loading = false;
    },
  },
  computed: {
    ...mapGetters(["getCourseLookup", "getSignup"]),
  },
};
</script>
